export function localeUpdate() {
    return {
        parentLocale: 'fr'
    };
}
